import axios from 'axios';
import { LOGO_URL } from 'constants/api';
import { GET_LOGO_URL, GET_LOGO_URL_SUCCESS, GET_LOGO_URL_FAILURE } from 'constants/actionTypes';

export const getAccountLogo = (accountId) => {
    const URL = `${ process.env.API_URL }${ LOGO_URL.replace('{accountId}', accountId) } `;
    return (dispatch) => {
        dispatch({ type: GET_LOGO_URL });
        return axios.get(URL)
            .then(response => {
                dispatch({ type: GET_LOGO_URL_SUCCESS, payload: response });
            })
            .catch((err) => {
                dispatch({ type: GET_LOGO_URL_FAILURE });
                throw err;
            });
    };
};
